import { gql, useQuery } from "@apollo/client";
import { Banner } from "gqlTypes";
import { useMemo } from "react";
import { featureIsToggled } from "utils/featureToggle";
import { FeatureToggle } from "gqlTypes";
import { getFragmentName } from "utils/query";

import { BANNER_QF } from "./bannerFragment";

export const QUERY = gql`
  query BannerQuery {
    banner {
      ...${getFragmentName(BANNER_QF)}
      __typename
    }
  }
  ${BANNER_QF}
`;

export type ResultsType = {
  banner: Banner | null;
};

const useBannerQuery = () => {
  const { data, ...status } = useQuery<ResultsType>(QUERY, {
    skip: !featureIsToggled(FeatureToggle.AdminBanner),
  });

  if (status.error) throw status.error;

  return useMemo(() => [data?.banner, status] as const, [data, status]);
};

export default useBannerQuery;
